/**
@example <some-table
      :list-items="reportsList"
      :indeterminate="indeterminate"
      :checkAll="checkAll"
      updateCheckOrder="onCheckOrder($event, 'keyList')" example ==> reportsList, contracts, list
      updateCheckOrders="onCheckOrders($event, 'keyList')" example ==> onCheckOrders($event, 'reportsList')
    ></some-table>
 */

export default {
	data: () => ({
		selected: [],
		indeterminate: false,
		checkAll: false,
	}),
	methods: {
		onCheckOrder(item, keyList, keyId) {
			const idx = this.selected.findIndex(selectedItem => selectedItem[keyId] === item[keyId]);
			if (idx === -1) {
				this.selected.push(item);
			} else {
				this.selected.splice(idx, 1);
			}

			if (!this.selected.length) {
				this.indeterminate = false;
				this.checkAll = false;
			}

			if (this.selected.length && (this.selected.length !== this[keyList].length)) {
				this.indeterminate = true;
			}

			if (this.selected.length === this[keyList].length) {
				this.indeterminate = false;
				this.checkAll = true;
			}
		},
		onCheckOrders(value, keyList) {
			if (value) {
				this.selected = this[keyList].map(item => item);
			} else {
				this.selected = [];
				this.indeterminate = false;
			}

			this.checkAll = value;

			this[keyList].forEach(item => {
				if (value && item.status === 'Open') {
					// Пропускаем установку true, если статус 'Open'
					item.isCheck = false;
				} else {
					item.isCheck = value;
				}
			});
		}
	},
};
